"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Value = exports.Label = exports.Description = exports.Ctas = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utilities = require("../../../utilities");
var _LexusTypography = require("../../LexusTypography");
var _breakpoints = _interopRequireDefault(require("../../breakpoints"));
const Label = exports.Label = _styledComponents.default.span`
  min-height: 18px;
  ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "body12"
})}
  color:
  ${function (_ref) {
  let {
    $textColor
  } = _ref;
  return $textColor ? (0, _utilities.colorToAlphaHex)($textColor, 0.7) : "#000000b2";
}};

  ${(0, _breakpoints.default)("desktop", "up")} {
    min-height: 20px;
    ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "body14"
})}
  }
`;
const Value = exports.Value = _styledComponents.default.span`
  min-height: 24px;
  ${function (_ref2) {
  let {
    $hasSmallFontSize: $isLongValue
  } = _ref2;
  return (0, _LexusTypography.nobel)({
    weight: $isLongValue ? "book" : "light",
    sizing: $isLongValue ? "subheading20" : "display72",
    spacing: $isLongValue ? "0.8px" : undefined
  });
}}
  ${function (_ref3) {
  let {
    $textColor
  } = _ref3;
  return $textColor && `color: ${$textColor}`;
}};

  ${(0, _breakpoints.default)("desktop", "up")} {
    min-height: 30px;
    ${function (_ref4) {
  let {
    $hasSmallFontSize: $isLongValue
  } = _ref4;
  return (0, _LexusTypography.nobel)({
    weight: $isLongValue ? "book" : "light",
    sizing: $isLongValue ? "heading24" : "display72",
    spacing: $isLongValue ? "0.8px" : undefined
  });
}}
  }
`;
const Description = exports.Description = _styledComponents.default.span`
  min-height: 20px;
  ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "body14"
})}
  height: 19px;
  color: #000000b2;
  ${function (_ref5) {
  let {
    $textColor
  } = _ref5;
  return $textColor && `color: ${(0, _utilities.colorToAlphaHex)($textColor, 0.7)}`;
}}
`;
const Ctas = exports.Ctas = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  width: 100%;
  border-top: 1px solid ${function (_ref6) {
  let {
    $borderColor
  } = _ref6;
  return $borderColor || "transparent";
}};
  padding: 40px 0;
  box-sizing: border-box;
`;